import { MDXLayout as Layout } from "@/shared/components/MDX/MDXLayout";
import { Alert } from "@/shared/components/MDX/MDXComponents";

# راهنمای ثبت شماره سریال قطعه/محصول

این بخش برای ثبت سریال در ایستگاه جاری و رهگیری دقیق زنجیره تولید در نظر گرفته شده است. این فرم مشخص می‌کند قطعه با چه شماره سریالی، در کدام مرحله تولید و در چه ایستگاهی ثبت می‌شود.

## ۱. انتخاب نسخه متریال
در لیست کشویی **نسخهٔ متریال (MaterialRevision)**، باید نسخه متریالی که در حال تولید یا ثبت است را از میان گزینه‌ها انتخاب کنید. بدون انتخاب این مورد امکان ثبت سریال وجود ندارد.

## ۲. تعیین مرحله ثبت سریال
سیستم سه حالت برای زمان و نحوه ثبت قطعه در نظر گرفته است:
- **هنگام ورود به انبار:** برای قطعاتی که هنگام دریافت و ورود به انبار سریال‌دهی می‌شوند.
- **حین تولید:** برای قطعات و نیمه‌ساخته‌هایی که در جریان فرآیندهای روی خط تولید سریال می‌خورند.
- **پایان تولید:** برای محصول نهایی که در آخرین مرحله پس از تکمیل، شماره سریال دریافت می‌کند.

## ۳. ایستگاه فعلی (Routing Operation)
از طریق منوهای کشویی مشخص کنید این قطعه در کدام ایستگاه و تحت چه سفارشی در حال پردازش است:
- **ایستگاه/عملیات مسیر (Routing Operation):** از لیست کشویی، ایستگاه یا مرحله‌ای که قطعه اکنون در آن قرار دارد را انتخاب کنید.
- **سفارش کار (Work Order) - اختیاری:** در صورت وجود، سفارش کاری مربوطه را از لیست انتخاب کنید تا شماره سریال به این سفارش متصل شود.

## ۴. اسکن یا وارد کردن شماره سریال
پس از تکمیل اطلاعات بالا، در بخش **شمارهٔ سریال (تایپ یا اسکن)** می‌توانید به کمک بارکدخوان، بارکد/کیوآرکد قطعه را اسکن کرده یا آن را به صورت دستی تایپ کنید (مثلاً `SN-00001`) و دکمه Enter را بزنید.

در صورتی که عملیات موفقیت‌آمیز باشد، پیام سبزرنگ مبنی بر ثبت موفق سریال نمایش داده می‌شود.

<Alert type="info">
با کلیک روی دکمه **مشاهدهٔ ردیابی** که در کنار پیام موفقیت ظاهر می‌شود، می‌توانید تاریخچه و وضعیت کامل قطعه‌ای که سریال آن هم‌اکنون ثبت شد را به سرعت در صفحه ردیابی بررسی نمایید.
</Alert>

<Alert type="warning">
**خطاهای احتمالی در زمان ثبت:** 
سیستم قوانین سخت‌گیرانه‌ای برای جلوگیری از اشتباهات اپراتوری دارد. به عنوان مثال، اگر قطعه اشتباهی را برای ایستگاه اسکن کنید (مثلاً عدم تطابق قطعه چپ و راست) یا سشن مرتبط با تغذیه پالت در این ایستگاه باز نباشد، از ثبت سریال جلوگیری شده و سیستم راهنمایی مشخصی را به زبان فارسی نمایش می‌دهد.
</Alert>

export default Layout;
